
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import useResponsive from '../../../node_modules/ahooks/es/useResponsive/index.js';
import Heading from '../Heading/Heading.js';
import Text from '../Text/Text.js';
import { container } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["icon", "title", "info", "heading", "size", "footer", "hideInfo", "hasBorder"];
var getIconSize = function getIconSize(isMd) {
  return {
    md: isMd ? 100 : 75,
    lg: isMd ? 180 : 135
  };
};
var Result = function Result(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    info = _ref.info,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? "h2" : _ref$heading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "lg" : _ref$size,
    footer = _ref.footer,
    _ref$hideInfo = _ref.hideInfo,
    hideInfo = _ref$hideInfo === void 0 ? false : _ref$hideInfo,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useResponsive = useResponsive(),
    md = _useResponsive.md;
  var Icon = icon;
  var iconSize = getIconSize(md);
  return jsx("article", _extends({
    "data-testid": "empty-state-container",
    css: function css(theme) {
      return container(theme, {
        size: size,
        hasBorder: hasBorder
      });
    }
  }, rest), Icon && jsx(React__default.Fragment, null, typeof Icon === "string" ? jsx("img", {
    src: Icon,
    height: iconSize[size],
    "data-testid": "result-icon",
    alt: "result image"
  }) : jsx(Icon, {
    height: iconSize[size],
    "data-testid": "result-icon"
  })), !hideInfo && jsx("div", {
    className: "body"
  }, jsx(React__default.Fragment, null, jsx(Heading, {
    as: heading,
    className: "result-header",
    "data-testid": "result-header"
  }, title), info && jsx(Text, {
    fontSize: size,
    as: "p",
    "data-testid": "result-info"
  }, info))), footer && jsx("footer", null, footer));
};

export { Result as default };
//# sourceMappingURL=Result.js.map
